/* eslint-disable */
export default {
  add: '추가',
  noCalls: '사용 가능한 통화 없음',
  activeCall: '활성 통화',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
